/**
 * Japanese language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_JA_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'マイページ',
    'lvt.menu.tw_profile': 'TW プロフィール',
    'lvt.menu.company_profile': '当社について',
    'lvt.menu.my_notifications': '通知',
    'lvt.menu.sign_out': 'ログアウト',

    // footer
    'lvt.footer.back_to_top': 'トップページに戻る',
    'lvt.footer.terms_of_use': '利用規約',
    'lvt.footer.privacy_policy': '個人情報',
    'lvt.footer.support_information': 'お困りの際は',
    'lvt.footer.transwide_home': 'トランスワイド ホーム',
    'lvt.footer.license_nr': 'ライセンスnr.:',
    'lvt.footer.build_version': 'バージョン:',

    // order list columns
    'lvt.order_list.header': '注文リスト',
    'lvt.order_list.column.shipperCompany': '輸送会社',
    'lvt.order_list.column.reference': 'Reference',
    'lvt.order_list.column.status': 'ステータス',
    'lvt.order_list.column.statusReason': 'ステータスについて',
    'lvt.order_list.column.senderCompany': '差出人 会社',
    'lvt.order_list.column.senderZipcode': '差出人 郵便番号',
    'lvt.order_list.column.senderCity': '差出人 都市',
    'lvt.order_list.column.receiverCompany': '受取人 会社',
    'lvt.order_list.column.receiverZipcode': '受取人 郵便番号',
    'lvt.order_list.column.receiverCity': '受取人 都市',
    'lvt.order_list.column.carrierName': '運送人の氏名',
    'lvt.order_list.column.plannedPickupEndDate': 'ピックアップ予定',
    'lvt.order_list.column.etaPickup': 'ETA　ピックアップ',
    'lvt.order_list.column.delayAtPickup': 'ピックアップの遅延',
    'lvt.order_list.column.plannedDeliveryEndDate': '配達予定',
    'lvt.order_list.column.etaDelivery': 'ETA 配達',
    'lvt.order_list.column.delayAtDelivery': '配達遅延',
    'lvt.order_list.column.timestamps': 'タイムスタンプ',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': '注文完了',
    'lvt.order_list.status.failed': 'エラー',
    'lvt.order_list.status.waiting': 'アクティブ',
    'lvt.order_list.status.active': 'アクティブ',
    'lvt.order_list.status.stopped': 'エラー',
    'lvt.order_list.status.completed': '完了',
    'lvt.order_list.status.cancelled': 'キャンセル済み',
    'lvt.order_list.status.timeout': '中止',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': '配達人が指定されていません',
    'lvt.order_list.status_reason.plate_number_not_present': 'ナンバープレートが登録されていません',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'ナンバープレートが確認できません',
    'lvt.order_list.status_reason.plate_number_not_operational': 'ナンバープレートの使用が出来ません',
    'lvt.order_list.status_reason.technical_error_not_posted': 'GHでご注文時に技術的問題が発生しました',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'ページごとの列',
    'lvt.order_list.pagination.first': '一番最初のページ',
    'lvt.order_list.pagination.previous': '戻る',
    'lvt.order_list.pagination.next': '次のページ',
    'lvt.order_list.pagination.last': '最後のページ',
    'lvt.order_list.pagination.no_orders_found': 'ご注文商品はありません',

    // tracked device
    'lvt.map.tracked_device.trailer': '追跡者',
    'lvt.map.tracked_device.tractor': 'トラクター',
    'lvt.map.tracked_device.mobile': 'モバイル端末',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'ご注文リスト',
    'lvt.map.traffic_information.traffic': '交通量',
    'lvt.map.traffic_information.fast': '早い',
    'lvt.map.traffic_information.slow': '遅い',
    'lvt.map.pickup_popup.pickup': 'ピックアップ',
    'lvt.map.pickup_popup.date': '日付',
    'lvt.map.pickup_popup.address': '住所',
    'lvt.map.delivery_popup.delivery': '配達',
    'lvt.map.delivery_popup.date': '日付',
    'lvt.map.delivery_popup.address': '住所',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': '配達中',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'ピックアップ待ち',
    'lvt.map.current_gps_popup.current_speed': '現在のスピード',
    'lvt.map.current_gps_popup.average_speed': '通常のスピード',
    'lvt.map.current_gps_popup.last_location_update': '最後の位置確認',
    'lvt.map.current_gps_popup.eta': 'ETA',
    'lvt.map.current_gps_popup.planned_time': '予定時間',
    'lvt.map.current_gps_popup.arrival_delay': '到着遅延',
    'lvt.map.current_gps_popup.speed_unit': 'km/h',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'スタート地点到着',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'スタート地点未到着',
    'lvt.order_list.timestamp.left_origin': 'スタート地点出発',
    'lvt.order_list.timestamp.not_left_origin': 'スタート地点未出発',
    'lvt.order_list.timestamp.arrived_at_destination': 'ゴール地点到着',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'ゴール地点未到着',
    'lvt.order_list.timestamp.left_destination': 'ゴール地点出発',
    'lvt.order_list.timestamp.not_left_destination': 'ゴール地点未出発',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-ja.ts